import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";

const EMAIL_PARAMS = ['verifyEmail', 'email'];

const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
    decoder: (str, name) => {
      if (!str) return '';

      // Хак для email параметров, чтобы не было проблем с отображением "+"
      if (EMAIL_PARAMS.includes(name)) {
        const tempStr = str.replace(/\+/g, '__PLUS__');
        const decoded = decodeURIComponent(tempStr);
        return decoded.replace(/__PLUS__/g, '+');
      }

      return decodeURIComponent(str);
    }
  });

  const updateQueryParams = useCallback(
    (newParams) => {
      const updatedParams = { ...queryParams, ...newParams };

      Object.keys(updatedParams).forEach((key) => {
        if (updatedParams[key] === undefined || updatedParams[key] === null) {
          delete updatedParams[key];
        }
      });

      navigate(`${location.pathname}?${qs.stringify(updatedParams)}`, { replace: true });
    },
    [location.pathname, navigate, queryParams]
  );

  const clearQueryParams = useCallback(() => {
    navigate(location.pathname, { replace: true });
  }, [location.pathname, navigate]);

  return {
    queryParams,
    updateQueryParams,
    clearQueryParams,
  };
};

export default useQueryParams;
